import React, { memo, useContext } from 'react'
import PropTypes from 'prop-types'

import { Button, Icon } from '../index'
import { util } from '../../../util'
import { LanguageContext } from '../../../context/LanguageContext'

const FilterToolBar = ({ clearAllHandler, closeSideMenuHandler, isClearAll }) => {
    const { strings } = useContext(LanguageContext)

    return (
        <div className={'filter-menu__header'}>
            <p className={'filterBy'}>{strings.FILTER_BY}</p>
            {isClearAll && (
                <Button
                    className={'px-2 clearAllBtn'}
                    variant={'basic'}
                    color={'primary'}
                    onClick={clearAllHandler}
                >
                    {strings.CLEAR_ALL}
                </Button>
            )}
            <Icon
                size={'sm'}
                pointer={true}
                onClick={closeSideMenuHandler}
                display={'inline'}
                className={'filterCloseIcon'}
                renderIcon={util.CloseIcon}
            />
        </div>
    )
}

FilterToolBar.propTypes = {
    clearAllHandler: PropTypes.func,
    closeSideMenuHandler: PropTypes.func,
    isClearAll: PropTypes.bool,
}

export default memo(FilterToolBar)
